import config from '@/assets/config.json';
import api from '../../api/index';
const state = {}
const mutations = {

}
const getters = {

}
const actions = {
 //预审核
 productPreAduit({
  rootState,
  commit
}, opt) {
  return new Promise((resolve, reject) => {
    api.put(`${config.newHttps.api}/merchant/goodsstandard/updatestatus`, opt).then(data => {
      if (data.data) {
        resolve(data.data);
      }
    }).catch((err) => {
      console.log(err);
    });
  });
},


  //营销玩法-活动效果数据统计和列表
  getActivitystatistics({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.brandHttps.api}/merchant/activity/link/statistics`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  //失效
  productInvalid({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.brandHttps.api}/merchant/activity/product/invalid`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },



  //搜索品牌分类
  getListbrand({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.brandHttps.api}/merchant/brands/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  //失效
  productInvalidAll({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/merchant/activity/goods/invalid `, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  //失效
  /* productInvalid({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.brandHttps.api}/merchant/activity/product/invalid`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  }, */





  //活动商品列表
  getDetailedList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/activity/goods/list`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },



  //活动产品详情列表
  activityDetailList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.brandHttps.api}/merchant/activity/product/detail/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },



  //获取活动名称
  goodsCheck({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/activity/goods/create`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  //获取活动名称

  getActivityName({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/activity/mains/name`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  //获取sku
  SkuList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/goods/sku/list`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  //物流接口-获取token
  logisticsToken({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.brandHttps.api}/merchant/activity/express/token`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  //订单管理 - 导出
  consignmentsExport({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.brandHttps.api}/merchant/activity/orders/consignments/export`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  //订单管理 - 物流节点
  logisticsGetTrajectory({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.logisticsHttps.api}/BaseApi/Logistics/GetTrajectory`, {
        params: opt,
        headers: {
          Authorization: "Bearer " + opt.token,
          'Content-Type': 'application/json; charset=UTF-8;',
        }
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  LogisticsDetails({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.brandHttps.api}/merchant/activity/express/detail`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  //订单管理 - 物流详情
  consignmentsDetails({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.brandHttps.api}/merchant/activity/orders/consignments/details`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  //订单管理 - 订单发货操作
  consignmentsCreate({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.brandHttps.api}/merchant/activity/orders/consignments/create`,
        opt
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  //物流接口-价格查询
  getExpressPrice({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.brandHttps.api}/merchant/activity/express/price`,
        opt
      ).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getBeiOrdertoken({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.brandHttps.api}/merchant/activity/express/token`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getBeiOrderInfo({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.orderHttps.api}/api/CallBack/QueryOrderDetailInfo`, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
        },
        params: opt,
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 订单管理 - 商品发货列表
  getOrdersConsignmentsList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.brandHttps.api}/merchant/activity/orders/goods/list`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 订单管理 - 物流发货列表订单管理 - 物流发货列表
  getConsignmentsList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.brandHttps.api}/merchant/activity/orders/consignments/list`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  //删除订单
  DeletConsignmentsList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.brandHttps.api}/merchant/activity/orders/consignments/cancel`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
    //押金订单列表
    getDepositList({
      rootState,
      commit
    }, opt) {
      return new Promise((resolve, reject) => {
        api.post(`${config.depositHttps.api}/merchant/deposit/order/list`, opt).then(data => {
          if (data.data) {
            resolve(data.data);
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    },
    //店铺押金信息
    getShopDepositInfo({
      rootState,
      commit
    }, opt) {
      return new Promise((resolve, reject) => {
        api.post(`${config.depositHttps.api}/merchant/deposit/shop/info`, opt).then(data => {
          if (data.data) {
            resolve(data.data);
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    },
    //押金支付
    payDepositOrder({
      rootState,
      commit
    }, opt) {
      return new Promise((resolve, reject) => {
        api.post(`${config.depositHttps.api}/merchant/deposit/order/pay`, opt).then(data => {
          if (data.data) {
            resolve(data.data);
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    },
    //押金支付结果检查
    payDepositCheck({
      rootState,
      commit
    }, opt) {
      return new Promise((resolve, reject) => {
        api.post(`${config.depositHttps.api}/merchant/deposit/order/paycheck`, opt).then(data => {
          if (data.data) {
            resolve(data.data);
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    },
    //押金详情
    getDepositDetail({
      rootState,
      commit
    }, opt) {
      return new Promise((resolve, reject) => {
        api.post(`${config.depositHttps.api}/merchant/deposit/order/detail`, opt).then(data => {
          if (data.data) {
            resolve(data.data);
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    },
    //线下支付保存
    payDepositOffline({
      rootState,
      commit
    }, opt) {
      return new Promise((resolve, reject) => {
        api.post(`${config.depositHttps.api}/merchant/deposit/order/offlinepay`, opt).then(data => {
          if (data.data) {
            resolve(data.data);
          }
        }).catch((err) => {
          console.log(err);
        });
      });
    },
  //获取活动标签（性别、年龄段、省份、城市）
  getTag({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/api/activity/gettag`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getGoodsList({
    rootState,
    commit
  }, opt) { //商品列表
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goodsmains/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  getGoodLei({
    rootState,
    commit
  }, opt) { //商品类目列表
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goodsclassifys/childlist`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getOrderList({
    rootState,
    commit
  }, opt) { //订单列表
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/order/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  uploadFile({
    rootState,
    commit
  }, opt) { //上传图片
    return new Promise((resolve, reject) => {
      api.post(`${config.updataImg.api}qcloud/cosupload`, opt,{headers: {
        "Content-Type": "multipart/form-data"
      }}).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // uploadFile({
  //   rootState,
  //   commit
  // }, opt) { //上传图片
  //   return new Promise((resolve, reject) => {
  //     api.post(`${config.centralHttps.api}/api/filesup/files`, opt).then(data => {
  //       if (data.data) {
  //         resolve(data.data);
  //       }
  //     }).catch((err) => {
  //       console.log(err);
  //     });
  //   });
  // },
  getGuiNameList({
    rootState,
    commit
  }, opt) { //获取规格名列表
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goodsattributesname/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  insertGuiName({
    rootState,
    commit
  }, opt) { //添加规格名
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goodsattributesname/create`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  insertGoods({
    rootState,
    commit
  }, opt) { //添加商品1
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/goods/add`, opt).then(data => {
        // api.post(`${config.shopHttps.api}/apimerchant/goodsmains/create`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  insertGuige({
    rootState,
    commit
  }, opt) { //添加规格
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goodsspecifications/patchsave`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  //查询北京订单管理商城订单列表
  getBeiOrderList({
    rootState,
    commit
  }, opt) { //订单金额统计
    return new Promise((resolve, reject) => {
      api.get(`${config.orderHttps.api}/api/BackCallBack/QueryMerchantInfo`, {
        params: opt,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  DeleteBeiOrderList({ //关闭北京收货接口
    rootState,
    commit
  }, opt) { //订单金额统计
    return new Promise((resolve, reject) => {
      api.get(`${config.orderHttps.api}/api/BackCallBack/QueryMerchantInfo`, {
        params: opt,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  ConfirmBeiOrderList({ //确认北京收货接口
    rootState,
    commit
  }, opt) { //订单金额统计
    return new Promise((resolve, reject) => {
      api.get(`${config.orderHttps.api}/api/BackCallBack/QueryMerchantInfo`, {
        params: opt,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getBeiOrderDetails({
    rootState,
    commit
  }, opt) { //订单金额统计
    return new Promise((resolve, reject) => {
      api.get(`${config.orderHttps.api}/api/BackCallBack/QueryMerchantOrderDetail`, {
        params: opt,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getBeiOrderDetailAddress({
    rootState,
    commit
  }, opt) { //订单金额统计
    return new Promise((resolve, reject) => {
      api.get(`${config.logisticsHttps.api}/api/Synthetical/GetLogisticsBaseInfo`, {
        params: opt,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getOrderPrice({
    rootState,
    commit
  }, opt) { //订单金额统计
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/order/statistics`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getOrderDetails({
    rootState,
    commit
  }, opt) { //订单详情
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/order/detail`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getExpressList({
    rootState,
    commit
  }, opt) { //快递公司列表
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/enum/express`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getProDetails({
    rootState,
    commit
  }, opt) { //商品详情
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goodsmains/details`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  //商家类目
  getKindType({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goodsclassifys/childlists`,
        opt
      ).then(data => {
        if (data) {
          resolve(data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getGuiDetails({
    rootState,
    commit
  }, opt) { //规格详情
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goodsspecifications/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 审核拒绝原因
  viewAuditsreason({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goods/viewauditsreason`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  proUpdate({
    rootState,
    commit
  }, opt) { //商品编辑
    return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/merchant/goods/edit`, opt).then(data => {
        // api.post(`${config.shopHttps.api}/apimerchant/goodsmains/modify`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  deletePro({
    rootState,
    commit
  }, opt) { //商品删除
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goodsmains/delete`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getExpro({
    rootState,
    commit
  }, opt) { //查找快递
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/express/detail`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  deliverGoods({
    rootState,
    commit
  }, opt) { //发货
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/order/consignment`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  couponskindList({
    rootState,
    commit
  }, opt) { //券列表
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/couponskind/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  couponskindDetail({
    rootState,
    commit
  }, opt) { //券详情
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/couponskind/detail`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  couponskindDelete({
    rootState,
    commit
  }, opt) { //券删除
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/couponskind/delete`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  couponskindCreate({
    rootState,
    commit
  }, opt) { //券创建
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/couponskind/create`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  getAllList({
    rootState,
    commit
  }, opt) { //活动运营-全部活动列表
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/alllist`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  getApplyList({
    rootState,
    commit
  }, opt) { //活动运营-全部活动列表
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/applylist`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  actApply({
    rootState,
    commit
  }, opt) { //活动运营-提交活动申请
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/apply`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  agebracket({
    rootState,
    commit
  }, opt) { //枚举-活动-年龄范围
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apiadministrator/enum/activity/agebracket`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  // 活动运营-需求申请
  postDemandApply({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/demandapply`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 活动运营-需求申请列表
  getDemandList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/demandlist`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 活动运营-需求详情
  getDemandDetail({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/demanddetail`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  // 活动运营-需求取消
  demandUpdate({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/demandupdate`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 消息列表
  getNoticeList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/notice/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 消息标记已读
  markRead({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/notice/markread`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 消息删除
  noticeDelete({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/notice/delete`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 商品列表
  newGoodsList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/goods/list`, {
        params: opt
      }).then(data => { // 新
        // api.post(`${config.shopHttps.api}/apimerchant/goods/list`, opt).then(data => { 旧
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 商品详情
  newGoodsDetail({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/goods/detail/${opt.id}`, {
        params: opt
      }).then(data => {
        // api.post(`${config.shopHttps.api}/apimerchant/goods/detail`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 商品上下架
  newUpdateStatus({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.put(`${config.newHttps.api}/merchant/goods/updatestatus/${opt.id}`, {
        token: opt.token,
        status: opt.status
      }).then(data => {
        // api.post(`${config.shopHttps.api}/apimerchant/goods/updatestatus`, opt).then(data => { 
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 商品删除
  newGoodsDelete({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.delete(`${config.newHttps.api}/merchant/goods/delete`, {
        params: opt
      }).then(data => {
        // api.post(`${config.shopHttps.api}/apimerchant/goods/delete`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },





  // 商家后台-活动原因-关联商品-列表
  goodActivityList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/goodactivity/goodlist`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  // 商家后台-活动状态枚举
  processStatus({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apiadministrator/enum/activity/process/status`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 商家后台-活动状态枚举
  totalList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/statistics/totallist`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  // 商家后台-数据统计列表
  statisticsList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/statistics/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  // 商家后台-数据统计详情
  statisticsDetail({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/statistics/detail`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 商家后台-活动运营-获取商家运营人的姓名和手机号
  activityGetInfo({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/getinfo`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  // 活动运营-查看活动关联的商品列表
  linkGoodsList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/linkgoodslist`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 活动运营-上传物料
  upInfo({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/upinfo`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 活动运营-获取订单信息
  getPayInfo({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/getpayinfo`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 活动运营-获取订单信息
  payActivity({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/payment/pay/activity`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  // 活动运营-海报列表
  posterList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/poster/list`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  // 活动运营-海报详情
  posterDetail({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/poster/detail`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 海报邮寄
  posterMail({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/poster/mail`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 海报邮寄
  posterExpressList({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/activity/poster/expresslist`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 查询支付结果
  paymentDetail({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.shopHttps.api}/apimerchant/payment/detail`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  GetShopAddress({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.brandHttps.api}/merchant/activity/express/send/address?token=${opt}`).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  ExpressDeliveryPric({
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.brandHttps.api}/merchant/activity/express/price/v2`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  InquireCashPledge({ //获取账户的押金
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.newHttps.api}/merchant/deposit/balance/info`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  GetShopVolume({ //获取商品的体积以及重量
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.newHttps.api}/merchant/local/property/data`, {
        params: opt
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  QueryRefundList({ //查询退款列表
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.orderHttps.api}/api/CallBack/QueryMerchantRefundsGoodsInfo`, {
        params: opt,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  QueryReturnedPurchase({ //查询退款列表
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.orderHttps.api}/api/CallBack/QueryMerchantRefundsGoodsInfo`,{
        params: opt,
        headers:{
          Authorization:'Bearer '+localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  QueryRefundConcet({ //查询退款详情
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.orderHttps.api}/api/CallBack/QueryMerchantRefundsDetail`, {
        params: opt,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  Surerefund({ //查询退款详情
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.brandHttps.api}/merchant/refund/api`, opt).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  OneAgreeReturn({ //第一次同意退货
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.orderHttps.api}/api/CallBack/UpRefundsDetailAgreeBtn`,opt,{
        headers:{
          Authorization:'Bearer '+localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  OneRefusedReturn({ //第一次拒绝退货
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.orderHttps.api}/api/CallBack/UpRefundsDetailAgreeBtn`,opt,
      {
        headers:{
          Authorization:'Bearer '+localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  TwoRefundsWatiReturn({ //第二次拒绝退货
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.orderHttps.api}/api/CallBack/UpRefundsWatiReturn`,opt,
      {
        headers:{
          Authorization:'Bearer '+localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  TwoUpRefundsWatiReturn({ //第二次拒绝退货
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.orderHttps.api}/api/CallBack/UpRefundsWatiReturn`,opt,
      {
        headers:{
          Authorization:'Bearer '+localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  Drawback({ //查询退款详情
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.orderHttps.api}/api/CallBack/RefundsGoodsStutus`, opt, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  Getlogistics({ //商品订单获取商品的发货地址
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.orderHttps.api}/local/goods/warehouse`, opt, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
        },
      }).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
		
  GetExpressNoAddress({ //商品订单获取商品的发货地址
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.depositHttps.api}/admin/restricted/area/besure`,{params:opt}).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  ExpressAddress({ //商品订单获取商品的发货地址
    rootState,
    commit
  }, opt) {
    return new Promise((resolve, reject) => {
      api.get(`${config.brandHttps.api}/merchant/activity/warehouse/address/address`,{params:opt}).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getWarehouseList({ //地址列表获取
    rootState,
    commit
}, opt) { //仓库地址管理-列表
    return new Promise((resolve, reject) => {
        api.post(`${config.logisticsHttps.api}/api/Adm_Address/GetList2`, opt,{
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
            },
        }).then(data => {
            if (data.data) {
                resolve(data.data);
            }
        }).catch((err) => {
            console.log(err);
        });
        // api.get(`${config.brandHttps.api}/merchant/warehouse/address/list`, {
        //     params: opt
        // }).then(data => {
        //     if (data) {
        //         resolve(data);
        //     }
        // }).catch((err) => {
        //     console.log(err);
        // });
    });
},
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
